import type { ApiType } from 'types/api_type';

export const adminsApi: Readonly<ApiType> = {
  path: '/admins',
};
